window.okeReviewsWidgetOnInit = function () {
    const writeAReviewButton = document.querySelector('.js-okeReviews-writeReview');
    const reviewsControl = document.querySelector('.okeReviews-reviews-controls');

    // Move WaR button
    if (writeAReviewButton && reviewsControl) {
        const reviewsControlSelect = reviewsControl.querySelector('.okeReviews-reviews-controls-select');
        reviewsControlSelect.insertAdjacentElement('afterbegin', writeAReviewButton);
    }
};